import {Search, Users} from "react-feather";
import {get} from "global/slices/clients/thunks";
import {Header as HeaderComponent, Input, Row} from "components";
import {
  useAppDispatch,
  useAppSelector,
  useBreakpoints,
  useDebouncedSearch,
} from "hooks";

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const dispatch = useAppDispatch();
  const {downXl, downMd} = useBreakpoints();
  const {pagination} = useAppSelector("clients");
  const {setQuery} = useDebouncedSearch({
    onDebounce: (ser) =>
      dispatch(get({...pagination, refresh: true, ser, pos: 0})),
    onEmptyQuery: () =>
      dispatch(get({...pagination, refresh: true, ser: "", pos: 0})),
  });

  return (
    <Row
      width="100%"
      gap={downMd ? 10 : 5}
      justifyContent="space-between"
      flexDirection={downXl ? "column" : "row"}
      alignItems={downXl ? "flex-start" : "center"}
    >
      <HeaderComponent icon={Users} children="Clientes" />
      <Row gap={1} alignItems="center">
        {/* <Dropdown
          listStyle={{width: 250}}
          style={{width: 230, borderRadius: 0}}
          // defaultValue={String(filter["id_zona"])}
          fieldStyle={{borderRadius: "8px 0 0 8px"}}
          onSelect={({value}) => {
            // dispatch(get({...filter, refresh: true, id_zona: Number(value)}));
          }}
          options={[
            {icon: RouteOutlined, label: "Estados", value: "0"},
            //  zones map
          ]}
        /> */}
        <Input
          icon={Search}
          placeholder="Buscar cliente"
          containerStyle={{maxWidth: "350px", marginBottom: 0}}
          onChange={({target}) => {
            setQuery(target["value"]);
          }}
        />
      </Row>
    </Row>
  );
};
